/* eslint-disable */
export default {
    cp_teams_navbar_title: "Teams",
    cp_teams_navbar_search_placeholder: "Zoek teams",
    cp_teams_general_error: "Er is een fout opgetreden bij het verwerken van uw verzoek.",
    cp_teams_sidebar_title: "Organisaties",
    cp_teams_sidebar_search_placeholder: "Zoek organisaties",
    cp_teams_team_card_manager: "Manager",
    cp_teams_team_card_type_team: "Team",
    cp_teams_team_card_teammembers: "Teamleden",
    cp_teams_footer_page: "Pagina",
    cp_teams_no_teams: "Geen teams gevonden",
    cp_teams_team_card_no_teammembers: "Geen teamleden",
    cp_teams_sidebar_empty_organisation: "No organisation found.",
    cp_teams_footer_save_button: "Opslaan",
    cp_teams_footer_status_saved: "Opgeslagen",
    cp_teams_footer_status_unsaved: "Wijzigingen zijn nog niet opgeslagen",
    cp_teams_navbar_back_button: "Terug naar Teams-overzicht",
    cp_teams_form_section_team_title: "Team",
    cp_teams_form_section_team_description: "Team instellingen",
    cp_teams_form_section_team_members_title: "Teamleden",
    cp_teams_form_section_team_members_description: "Beheer de leden van het team",
    cp_teams_form_section_team_field_name_label: "Teamnaam",
    cp_teams_form_section_team_members_field_search_placeholder: "Zoek teamleden",
    cp_teams_form_section_team_members_field_search_no_results: "Geen resultaten",
    cp_teams_form_section_team_members_button_add: "Voeg teamlid toe",
    cp_teams_form_saved: "Het team is opgeslagen",
    cp_teams_generic_error: "Er is iets misgegaan",
    cp_teams_create_new_team_button_label: "Team aanmaken",
    cp_teams_team_created_successfully_message: "Het team is succesvol samengesteld",
    cp_teams_new_team_modal_title: "Welk team ben je aan het creëren?",
    cp_teams_new_team_modal_subtitle: "Bepaal alle instellingen van dit nieuwe team",
    cp_teams_new_team_modal_organisation_setting_title: "Organisatie van dit team",
    cp_teams_new_team_modal_organisation_setting_description: "Daar vindt u uw deelnemers",
    cp_teams_new_team_modal_name_setting_title: "Teamnaam",
    cp_teams_new_team_modal_name_setting_description: "Wat is de naam van dit team?",
    cp_teams_new_team_modal_variant_setting_description: "Wat voor soort team is dit?",
    cp_teams_new_team_modal_variant_setting_title: "Type team",
    cp_teams_advisory_team_title: "Adviesteam",
    cp_teams_advisory_team_description: "Experts die strategisch advies, inzichten en aanbevelingen geven ter ondersteuning van besluitvorming binnen een specifiek vakgebied.",
    cp_teams_creative_team_title: "Creatief team",
    cp_teams_creative_team_description: "Professionals die samenwerken om ideeën te ontwikkelen en creatieve content te produceren, vaak in sectoren zoals marketing, design of media.",
    cp_teams_management_team_title: "Managementteam",
    cp_teams_management_team_description: "Leidinggevenden verantwoordelijk voor het bepalen van de koers, het nemen van strategische beslissingen en het aansturen van de organisatie.",
    cp_teams_operational_team_title: "Operationeel team",
    cp_teams_operational_team_description: "Verantwoordelijk  voor het uitvoeren van terugkerende, dagelijkse taken ter ondersteuning van de kernactiviteiten van een organisatie.",
    cp_teams_project_team_title: "Projectteam",
    cp_teams_project_team_description: "Een tijdelijke groep die wordt samengesteld om specifieke doelen te realiseren binnen een afgesproken tijd en scope.",
    cp_teams_service_team_title: "Serviceteam",
    cp_teams_service_team_description: "A groep van professionals die samen werken in de rol van ondersteuning voor interne of externe klanten",
    cp_teams_unknown_team_description: "Te gebruiken wanneer de overige opties niet passend zijn",
    cp_teams_unknown_team_title: "Overig",
    cp_teams_empty_report_title: "Rapportgeneratie mislukt",
    cp_teams_empty_report_text: "Navigeer naar de overzichtspagina voor teams",
    cp_teams_role_applicant: "Sollicitant",
    cp_teams_role_member: "Teamlid",
    cp_teams_role_manager: "Teamleider",
    cp_teams_add_team_member_modal_field_participant_label: "Deelnemer",
    cp_teams_add_team_member_modal_field_participant_placeholder: "Selecteer deelnemer",
    cp_teams_add_team_member_modal_field_role_label: "Rol",
    cp_teams_add_team_member_modal_field_role_placeholder: "Selecteer rol",
    cp_teams_add_team_member_modal_title: "Voeg een nieuw teamlid toe",
    cp_teams_add_team_member_modal_subtitle: "Wie wil je aan dit team toevoegen?",
    cp_teams_add_team_member_modal_field_participant_error: "Selecteer een deelnemer",
    cp_teams_add_team_member_modal_field_role_error: "Selecteer de rol"
};
